// Guards the file inputs flagged with `data-file-required`.
//
// Those inputs are dressed by dropify, which hides the real control. A native
// `required` attribute on a hidden input makes Chrome refuse the submit with
// "An invalid form control is not focusable" and show nothing, and jQuery
// Validate skips hidden fields, so neither reports the missing file. The check
// below runs on submit instead, blocks it and points at the field (WP #16393).
//
// It listens in the capture phase: the study modal validates in the bubble
// phase, and its submit handler hides the modal and opens the loader, which
// must not happen when the form is going nowhere.
//
// An input already holding a file server-side carries `data-file-attached`, so
// an edit form does not ask for it again.
const REQUIRED_FILE_SELECTOR = "[data-file-required]";

// Forms already carrying the listener. Kept JS-side on purpose: a flag written
// on the element would be serialized into the Turbolinks page snapshot, and a
// cached back/forward restore would bring the flag back without the listener,
// leaving the form unguarded.
const boundForms = new WeakSet();

function isFilled(input) {
  if (input.dataset.fileAttached === "true") {
    return true;
  }

  return input.files && input.files.length > 0;
}

function errorSlot(input) {
  const $wrapper = $(input).closest("td, .form-group");
  const $existing = $wrapper.find(".js-file-required-error");

  if ($existing.length) {
    return $existing;
  }

  return $("<div class='text-danger fs-12 mt-1 js-file-required-error'></div>").appendTo($wrapper);
}

function showError(input) {
  errorSlot(input).text(input.dataset.fileRequiredMessage || "").show();
  $(input).closest(".dropify-wrapper").addClass("border-danger");
}

function clearError(input) {
  errorSlot(input).hide();
  $(input).closest(".dropify-wrapper").removeClass("border-danger");
}

function missingFiles(form) {
  return Array.from(form.querySelectorAll(REQUIRED_FILE_SELECTOR)).filter((input) => {
    if (input.disabled || isFilled(input)) {
      clearError(input);
      return false;
    }

    showError(input);
    return true;
  });
}

function onSubmit(event) {
  const missing = missingFiles(event.currentTarget);

  if (!missing.length) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  // The field may sit below the fold or in another step of the form.
  const anchor = $(missing[0]).closest(".dropify-wrapper, td, .form-group")[0];
  if (anchor && anchor.scrollIntoView) {
    anchor.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

export function initRequiredFileFields(root = document) {
  const inputs = Array.from(root.querySelectorAll(REQUIRED_FILE_SELECTOR));

  inputs.forEach((input) => {
    $(input).off("change.requiredFile").on("change.requiredFile", () => {
      if (isFilled(input)) {
        clearError(input);
      }
    });

    const form = input.form;
    if (!form || boundForms.has(form)) {
      return;
    }

    boundForms.add(form);
    form.addEventListener("submit", onSubmit, true);
  });
}

// Turbolinks replaces the body on navigation, so re-run on every page load.
["DOMContentLoaded", "turbolinks:load"].forEach((event) => {
  document.addEventListener(event, () => initRequiredFileFields());
});
